import GreenPageSection from 'components/GreenPageSection';
import PopupWithDimmedBackground from 'components/PopupWithDimmedBackground';
import RoundedButton from 'components/RoundedButton';
import Subheading from 'components/Subheading';
import { useState } from 'react';
import { ASSET_PREFIX } from 'utils/constants';

const TestimonialAdSection = () => {
  const [showPopup, setShowPopup] = useState(false);
  return (
    <GreenPageSection>
      <Subheading>
        Fancy Another <strong>One?</strong>
      </Subheading>

      <p className="medium text-centered">
        Send us a video testimonial and score yourself a{' '}
        <strong>FREE Bronze prize</strong> of your choice!
      </p>

      <RoundedButton
        style={{ minWidth: '200px', margin: '1em' }}
        onClick={async () => {
          setShowPopup(true);
        }}
      >
        Find Out More
      </RoundedButton>

      {showPopup && (
        <PopupWithDimmedBackground
          icon={`${ASSET_PREFIX}/images/testimonial-popup/icon.png`}
          onClose={() => setShowPopup(false)}
        >
          <p className="xlarge xbold">Lights, Camera, Action!</p>

          <p className="medium">
            Send us a video testimonial for our socials and marketing telling us
            and the DAYMADE fam about your DAYMADE experience to score yourself
            a <strong>Bronze prize</strong> of your choice!
          </p>

          <p className="medium bold">The video must be:</p>

          <div className="videoRequirementsGrid">
            <img
              src={`${ASSET_PREFIX}/images/testimonial-popup/landscape.png`}
              alt=""
              className="icon"
              style={{
                height: 24,
              }}
            />
            <div className="text">Filmed in landscape</div>

            <img
              src={`${ASSET_PREFIX}/images/testimonial-popup/duration.png`}
              alt=""
              className="icon"
              style={{
                height: 30,
              }}
            />
            <div className="text">30s - 60s long</div>

            <img
              src={`${ASSET_PREFIX}/images/testimonial-popup/email.png`}
              alt=""
              className="icon"
              style={{
                height: 27,
              }}
            />
            <div className="emailTo text">Emailed to hello@daymade.co.uk</div>
          </div>

          <RoundedButton
            style={{ minWidth: '200px', margin: '1em' }}
            onClick={() => setShowPopup(false)}
          >
            Got It!
          </RoundedButton>

          <p style={{ marginTop: '1.5em' }}>
            <em>
              * This offer can only be claimed once per person. By submitting a
              video, you consent to us using that video for marketing purposes.
            </em>
          </p>

          <style jsx>
            {`
              .videoRequirementsGrid {
                margin: 1.25em auto 2em;
                padding-left: 1em;
                width: 100%;
                display: grid;
                grid-template-columns: 1fr 5fr;
                gap: 2em 1em;
                align-items: center;
                text-align: left;
              }

              .videoRequirementsGrid .icon {
                justify-self: center;
              }

              .videoRequirementsGrid .text {
                font-size: 0.9rem;
                font-weight: 700;
                justify-self: start;
              }

              @media (min-width: 500px) {
                .videoRequirementsGrid {
                  margin: 1.5em auto 2em;
                  grid-template-columns: 1fr 1fr 1fr;
                  gap: 10px;
                  justify-items: center;
                  align-items: center;
                  padding: 0;
                }

                .videoRequirementsGrid .icon {
                  grid-row: 1 / 2;
                }

                .videoRequirementsGrid .text {
                  grid-rows: 2 / 3;
                  align-self: start;
                  justify-self: center;
                  font-size: 0.9rem;
                  font-weight: 700;
                  text-align: center;
                }

                .videoRequirementsGrid .text:not(.emailTo) {
                  max-width: 70px;
                }
              }
            `}
          </style>
        </PopupWithDimmedBackground>
      )}
    </GreenPageSection>
  );
};

export default TestimonialAdSection;
